import { ITietThiActionTypes } from "../../action-types/tct/ITietThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITietThiReducer } from "../../reducer-model/tct/ITietThiReducer";

const iniState: ITietThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  tietThis: [],
  selectedIds: []
};
export const tietThiReucer = (
  state: ITietThiReducer = iniState,
  action: ITietThiActionTypes
): ITietThiReducer => {
  switch (action.type) {
    case "TIET_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "TIET_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        tietThis: action.payload,
        selectedIds: []
      };
    case "TIET_THI_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "TIET_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        tietThiEditing: action.payload,
        isShowEditModal: true
      };
    case "TIET_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "TIET_THI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "TIET_THI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "TIET_THI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "TIET_THI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "TIET_THI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "TIET_THI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "TIET_THI_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    default:
      return state;
  }
};
